<template>
  <div :class="['battleReport' + posterData.teamStatus, currentSeason]" class="battleReport">
    <img class="posterBg" :src="battleReportBg" v-if="battleReportBg"  />
    <main
      :class="[
        type === 'day' ? (win === true ? 'win-main' : 'notWin-main') : '',
        isSpring ? 'spring' : '',
      ]"
    >
      <div v-if="!isSpring && posterData.teamStatus == 1" class="status_1">
        <section>
          <p>
            {{ timeFormatFilter(posterData.date) }}
          </p>
          <address>{{ teamInfo.servicePointName }}</address>
          <h3>{{ teamInfo.teamName }}</h3>
        </section>
        <footer>
          <dl>
            <dt>累计奖杯数</dt>
            <dd>{{ posterData.cupNumber | formatNumberFilter }}</dd>
          </dl>

          <dl>
            <dt>PK局数</dt>
            <dd>{{ posterData.pkCount | formatNumberFilter }}</dd>
          </dl>
        </footer>
      </div>
      <div v-if="!isSpring && posterData.teamStatus == 2" class="status_2">
        <section>
          <p>
            {{ timeFormatFilter(posterData.date) }}
          </p>
          <address>{{ teamInfo.servicePointName }}</address>
          <h3>{{ teamInfo.teamName }}</h3>
        </section>
        <footer>
          <dl>
            <dt>单日奖杯数</dt>
            <dd>{{ posterData.cupNumber | formatNumberFilter }}</dd>
          </dl>

          <dl>
            <dt>胜利局数</dt>
            <dd>{{ posterData.cupWinNumber | formatNumberFilter }}</dd>
          </dl>
        </footer>
      </div>
      <div v-if="posterData.teamStatus == 3" class="status_3">
        <header
          :class="[
            type === 'day'
              ? win === true
                ? 'win-header'
                : 'notWin-header'
              : '',
          ]"
        >
         
          <template v-if="!isSpring && type != 'day'">
            <p v-if="[2, 3, 7].includes(posterData.gameType)" class="game-stage-name">{{ posterData.name  }}</p>
            <p class="tag">
              <!-- <span class="text1">战队战绩</span
              > -->
              <!-- <span class="text2">2023.1.9</span> -->
              <span
                :class="[isSpring? (posterData.gameType === 6 || posterData.gameType === 7
                    ? 'text3-2'
                    : 'text3'):'text4']
                "
                >{{ timeFormatFilter2(posterData.date) }}</span
              >
            </p>
          </template>
          <template v-if="isSpring">
            <h3>{{ posterData.warZone || "金牛座战区" }}</h3>
            <div>
              第<b>{{ posterData.rank }}</b
              >名
            </div>
          </template>
          <template
            v-if="
              !isSpring &&
              (posterData.gameType === 1 ||
                posterData.gameType === 2 ||
                posterData.gameType === 3 ||
                posterData.gameType === 4 ||
                posterData.gameType === 6 ||
                posterData.gameType === 7 ||
                posterData.gameType === 8 ||
                posterData.gameType === 9 ||
                posterData.gameType === 10) &&
              type != 'day'
            "
          >
            <template v-if="posterData.gameType === 1">
              <h3>全网大乱斗</h3>
              <div>
                第<b>{{ posterData.rank }}</b
                >名
              </div>
            </template>
            <template v-if="posterData.gameType === 2">
              <h3>{{ posterData.warZone }}</h3>
              <div>
                第<b>{{ posterData.ware_zone_rank }}</b
                >名
              </div>
            </template>
            <template v-if="posterData.gameType === 3">
              <h3>{{ posterData.group_name }}</h3>
              <div>
                第<b>{{ posterData.ware_zone_rank }}</b
                >名
              </div>
            </template>
            <!-- 全国赛淘汰赛的时候用 name 字段 -->
            <template v-if="posterData.gameType === 4">
              <div>
                <b>{{ posterData.name.replace("战队", "") }}</b>
              </div>
            </template>
            <!-- TODO 竞技场的排名字段 -->
            <template
              v-if="posterData.gameType === 6"
            >
              <h3>竞技场大乱斗</h3>
              <div>
                第<b>{{ posterData.rank }}</b
                >名
              </div>
            </template>
            <template v-if="posterData.gameType === 7 ">
              <h3>{{ posterData.warZone }}战区</h3>
              <div>
                第<b>{{ posterData.ware_zone_rank }}</b
                >名
              </div>
            </template>
            <template v-if="posterData.gameType === 8 ">
              <h3>{{ posterData.warZone }}战区</h3>
              <div>
                第<b>{{ posterData.ware_zone_rank }}</b
                >名
              </div>
            </template>
            <template v-if="posterData.gameType === 10 ">
              <h3>{{ posterData.warZone }}战区</h3>
              <div>
                第<b>{{ posterData.ware_zone_rank }}</b
                >名
              </div>
            </template>
            <template v-if="posterData.gameType === 9">
              <h3 class="hot-body-title">热身赛</h3>
              <div class="hot-body-content">
                第<b>{{ posterData.ware_zone
                      ? posterData.ware_zone_rank
                      : posterData.sched_rank }}</b
                >名
              </div>
            </template>
          </template>
          <!-- <template v-if="!isSpring && gameType === 4 && type != 'day'">
            <div>
              全国<b>{{ posterData.country_rank }}</b
              >强
            </div>
          </template> -->
          <template v-if="!isSpring && type == 'day'">
            <div>
              每日战报
              <p>{{ timeFormatFilter(posterData.date) }}</p>
            </div>
          </template>
        </header>
        <section
          :class="[
            type === 'day' && win === true
              ? 'win-section'
              : !isSpring
              ? 'notWin-section'
              : '',
          ]"
        >
          <address>{{ teamInfo.servicePointName || "松鼠服务中心" }}</address>
          <h3 :class="[isSpring ? '' :  `${currentSeason}-hbg`]">{{ teamInfo.teamName }}</h3>
        </section>
        <div v-if="type === 'day' && win === true" class="win-img">
          <img
            src="../../../../assets/images/squirrelCup/2025/summer/poster/memberJb.png"
          />
        </div>
        <footer
          :class="[
            type === 'day' && win === true
              ? 'win-footer'
              : !isSpring
              ? 'notWin-footer'
              : '',
          ]"
        >
          <dl>
            <dt>
              <template v-if="type === 'day' && win === true"
                >单日奖杯数</template
              ><template v-else>累计奖杯数</template>
            </dt>
            <dd :class="[isSpring ? '' :  `${currentSeason}-bg`]">{{ posterData.cupNumber | formatNumberFilter }}</dd>
          </dl>

          <dl>
            <dt>
              <template v-if="type === 'day' && win === true">胜利局数</template
              ><template v-else>PK局数</template>
            </dt>
            <dd  :class="[isSpring ? '' : `${currentSeason}-bg`]" v-if="type === 'day' && win === true">{{ posterData.cupWinNumber | formatNumberFilter }}</dd>
            <dd  :class="[isSpring ? '' : `${currentSeason}-bg`]" v-else>{{ posterData.pkCount | formatNumberFilter }}</dd>
          </dl>
        </footer>
        <!-- 晋级的标志 -->
        <div v-if="posterData.advancement === 1" class="advancement-img">
          <img src="../../../../assets/images/winterGame/promoted_icon_inner.png" />
        </div>
      </div>
      <div v-if="!isSpring && posterData.teamStatus == 4" class="status_4">
        <section>
          <address class="address">{{ teamInfo.servicePointName }}</address>
          <p class="teamName">{{ teamInfo.teamName }}</p>
        </section>
        <div class="zoneName">
          <p>{{ posterData.warZone }}</p>
        </div>
        <footer>
          <p class="date">
            {{ timeFormatFilter(posterData.sched_date) }}
          </p>
          <img src="../../../../assets/images/winterGame/poster/committeeSeal.png" class="committeeSeal-icon"/>
        </footer>
      </div>
    </main>
  </div>
</template>

<script>
import { queryseasonteamposterfrontconfig } from "@/api/winterGame";
import { Toast } from "vant";

import {
  timeFormatFilter,
  timeFormatFilter2,
  judgeTempSeason,
} from "@/util/util.js";
import { remoteImageToDataUrl } from "@/util/posterCapture";
export default {
  name: "battleReport",
  data() {
    return {
      battleReportBg: null,
      isSpring: false,
      type: "no", //day
      win: false,
      currentSeason: '',
      postData: {},
      isImageLoaded: false, // 标记图片是否已加载完成
    };
  },
  props: {
    posterData: {
      type: Object,
      default: function () {
        return {
          date: "",
          cupNumber: 0,
          warZone: "",
          rank: 0,
          cupWinNumber: 0,
          pkCount: 0,
          teamStatus: 0,
          ware_zone_rank: 0,
          country_rank: 0,
          name: "",
          group_name: "",
          date: "",
          gameType: 0,
          advancement: 0,
          settled_team_win_count: 0,
        };
      },
    },
    teamInfo: {
      type: Object,
      default: null,
    },
  },
  watch: {
    // 监听图片 URL 变化，重置加载状态
    battleReportBg: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          // 当图片 URL 变化时，重置加载状态
          this.isImageLoaded = false;
          // 使用 nextTick 确保 DOM 更新后检查图片是否已从缓存加载
          this.$nextTick(() => {
            const img = this.$el && this.$el.querySelector('.posterBg');
            if (img && img.complete && img.naturalHeight !== 0) {
              // 图片已从缓存加载完成，直接触发
              this.createSaveImage();
            }
          });
        }
      },
      immediate: false
    }
  },
  async mounted() {
    // 每次组件挂载时，先清空图片和加载状态，避免显示旧图片
    this.battleReportBg = null;
    this.isImageLoaded = false;
    
    const teamInfo = JSON.parse(localStorage.getItem('teamInfo')) || {};
    if (teamInfo && teamInfo.currentSeasonId) {
      this.currentSeasonId = teamInfo.currentSeasonId;
      const res = await this.querySeasonTeamPosterFrontConfig(this.currentSeasonId);
      if (res.code == 0) {
        this.postData = res.data;
      } else {
        Toast(res.message);
      }
    }
    // let [isSpring, year, season] = judgeTempSeason();
    // if (this.$route.query.seasonId) {
    //   let { seasonId } = this.$route.query;
    //   if (seasonId.indexOf("chunji") > -1) {
    //     isSpring = true;
    //     this.isSpring = true;
    //     season = "spring";
    //   } else if (seasonId.indexOf("xiaji") > -1) {
    //     isSpring = false;
    //     this.isSpring = false;
    //     season = "summer";
    //   } else if (seasonId.indexOf("qiuji") > -1) {
    //     isSpring = false;
    //     this.isSpring = false;
    //     season = "autumn";
    //   } else {
    //     isSpring = false;
    //     this.isSpring = false;
    //     season = "winter";
    //   }
    //   if (seasonId.indexOf('s.23') > -1) {
    //     year = '2023';
    //   } else if (seasonId.indexOf('s.24') > -1) {
    //     year = '2024';
    //   } else if (seasonId.indexOf('s.25') > -1) {
    //     year = '2025';
    //   }
    // }
    
    // this.currentSeason = `${season}-${year}`;
    if ((this.posterData.teamStatus === 1 || this.posterData.teamStatus === 2)) {
      this.type = "day";
      if (this.posterData.teamStatus === 1) {
        this.win = false;
      } else if (this.posterData.teamStatus === 2) {
        this.win = true;
      }
      this.posterData.teamStatus = 3; //必须转为 3
    }
    if (this.posterData.gameType == 7) {
      this.posterData.teamStatus = 3; 
    }
    // if (this.isSpring) {
    //   if (this.posterData.teamStatus == 2) {
    //     this.battleReportBg = battleReportBg2;
    //   } else {
    //     this.battleReportBg = battleReportBg1;
    //   }
    // } else if (!this.isSpring) {
      
    // }
    if (this.type == "day") {
      if (this.win == true && this.postData.teamDailyWinImage) {
        //2 是没有 jb图 的
        this.battleReportBg = this.postData.dayReportWinImage;
      } else {
        this.battleReportBg = this.postData.teamDailyImage;
      }
    } else {
      if (this.posterData.gameType == 6 && this.postData.teamRecordImage) {
        //竞技场的有荣誉的也应该是这个竞技场的背景
        this.battleReportBg = this.postData.teamRecordImage;
      } else if (this.posterData.gameType == 7) {
        const { ware_zone_rank } = this.posterData;
        if (new Date() < new Date(this.posterData.sched_end_date && this.postData.teamRecordImage)) {
          this.battleReportBg = this.postData.teamRecordImage;
        } else {
          if (ware_zone_rank == 1 && this.postData.arenaRegionChampionImage) {
            this.battleReportBg = this.postData.arenaRegionChampionImage;
          } else if (ware_zone_rank == 2 && this.postData.arenaRegionRunnerUpImage) {
            this.battleReportBg = this.postData.arenaRegionRunnerUpImage;
          } else if (ware_zone_rank == 3 && this.postData.arenaRegionThirdPlaceImage) {
            this.battleReportBg = this.postData.arenaRegionThirdPlaceImage;
          } else {
            if (this.postData.teamRecordImage) {
              this.battleReportBg = this.postData.teamRecordImage;
            }
          }
        }
      } else {
        if (this.postData.teamRecordImage) {
          this.battleReportBg = this.postData.teamRecordImage;
        }
      }
    }
    if (this.battleReportBg && (String(this.battleReportBg).indexOf('http') === 0 || String(this.battleReportBg).indexOf('//') === 0)) {
      this.battleReportBg = await remoteImageToDataUrl(this.battleReportBg);
    }
    this.waitForBgReady().then(() => {
      this.$emit('poster-ready', this.$el);
    });
  },
  methods: {
    waitForBgReady() {
      return new Promise((resolve) => {
        if (!this.battleReportBg) {
          this.$nextTick(resolve);
          return;
        }
        this.$nextTick(() => {
          const img = this.$el && this.$el.querySelector('.posterBg');
          if (!img) {
            resolve();
            return;
          }
          if (img.complete) {
            resolve();
            return;
          }
          const timer = setTimeout(resolve, 15000);
          const done = () => {
            clearTimeout(timer);
            resolve();
          };
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
      });
    },
    querySeasonTeamPosterFrontConfig(currentSeasonId) {
      return new Promise((resolve, reject) => {
        queryseasonteamposterfrontconfig({
          param: {
            seasonTagId: currentSeasonId
          }
        }).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
    timeFormatFilter(date) {
      return timeFormatFilter(date);
    },
    timeFormatFilter2(date) {
      return timeFormatFilter2(date);
    },
  },
};
</script>

<style lang="less" scoped>
.battleReport {
  display: flex;
  flex-direction: column;
  img.posterBg {
    width: 100%;
  }
  .win-main {
    top: 650px !important;
  }
  .notWin-main {
    top: 700px !important;
  }
  main {
    position: absolute;
    top: 570px;
    left: 0;
    right: 0;
    address {
      font-style: normal;
    }
  }
  .spring {
    top: 650px !important;
  }
  &.battleReport1 {
    main {
      position: absolute;
      top: 612px;
      left: 0;
      right: 0;
    }
  }
  &.battleReport3 {
    main {
      position: absolute;
      // top: 47vh;
      left: 0;
      right: 0;
    }
  }
  .status_1 {
    section {
      text-align: center;
      color: #ffffff;
      position: relative;
      &:first-child {
        p {
          text-align: left;
          margin: 0 0 0 23%;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
        }
        address {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 44px;
          font-weight: normal;
          font-style: normal;
        }
        h3 {
          margin: 16px auto 0 auto;
          width: 640px;
          height: 132px;
          font-size: 56px;
          background: url("../../../../assets/images/winterGame/poster/barBg.png")
            no-repeat;
          background-size: contain;

          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 132px;
        }
      }
    }
    footer {
      margin-top: 96px;
      dl {
        text-align: center;
        margin: auto;
        dt {
          height: 48px;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 48px;
        }
        dd {
          background: url("../../../../assets/images/winterGame/poster/barBg.png")
            no-repeat;
          background-size: contain;
          height: 92px;
          width: 454px;
          margin: auto;
          font-size: 64px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 92px;
        }
        &:first-child {
          margin-bottom: 46px;
        }
      }
    }
  }

  .status_2 {
    section {
      text-align: center;
      color: #ffffff;
      position: relative;
      &:first-child {
        p {
          margin: 0;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
        }
        address {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 44px;
        }
        h3 {
          margin: 16px auto 0 auto;
          height: 102px;
          width: 588px;
          background: url("../../../../assets/images/winterGame/poster/mvpBarBg.png")
            center no-repeat;
          background-size: contain;
          font-size: 48px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #fbf497;
          line-height: 102px;
        }
      }
    }
    footer {
      margin-top: 290px;
      dl {
        text-align: center;
        margin: auto;
        dt {
          height: 48px;
          font-size: 34px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 48px;
        }
        dd {
          height: 100px;
          width: 454px;
          background: url("../../../../assets/images/winterGame/poster/mvpBarBg.png")
            center no-repeat;
          background-size: contain;
          margin: auto;
          font-size: 70px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #fbf497;
          line-height: 100px;
        }
        &:first-child {
          margin-bottom: 46px;
        }
      }
    }
  }

  .status_3 {
    .win-header {
      position: relative;
      top: -40px;
      height: auto !important;
      margin-bottom: 20px !important;
    }
    .notWin-header {
      position: relative;
      top: -40px;
      height: auto !important;
      margin-bottom: 70px !important;
    }
    .win-section {
      // z-index: 1000;
      h3 {
        background: url("../../../../assets/images/squirrelCup/2023/summer/yellow_bar_bg.png")
          center no-repeat !important;
        background-size: contain !important;
        color: #fbf497!important;
      }
    }
    .hot-body-title {
      margin-top: 70px;
    }
    .hot-body-content {
      margin-bottom: 60px;
    }
    .notWin-section {
      h3 {
        color: #F9F700;
      }
    }
    .win-img {
      // width: 100%;
      display: flex;
      justify-content: center;
      position: relative;
      top: 44px;
      width: 100%;
      height: 136px;
      img {
        display: block;
        width: 127px;
        height: 136px;
      }
    }
    .win-footer {
      position: relative;
      top: 90px;
      margin-top: 0;
      dd {
        background: url("../../../../assets/images/squirrelCup/2023/summer/yellow_bar_small_bg.png")
          center no-repeat !important;
        background-size: cover !important;
        color: #fbf497!important;
        font-size: 76px;
      }
    }
    .notWin-footer {
      dd {
        color: #6dfffd;
      }
    }
    header {
      text-align: center;
      margin-bottom: 56px;

      display: flex;
      flex-direction: column;
      justify-content: center;

      .game-stage-name {
        position: relative;
        top: -53px;
        margin: 0;
        padding: 0;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 40px;
        color: #FBF497;
        line-height: 60px;
        text-align: center;
        font-style: normal;
      }
      .tag {
        width: 100%;
        margin: 0;
        height: 30rpx;
        display: flex;
        justify-content: center;
        // position: absolute;
        // top: -10px;
        // left: -85px;
        // .text1 {
        //   font-size: 32px;
        //   font-family: PingFangSC-Regular, PingFang SC;
        //   font-weight: 400;
        //   color: #ffffff;
        //   line-height: 44px;
        //   display: inline-block;
        //   margin-right: 20px;
        // }
        // .text2 {
        //   font-size: 32px;
        //   font-family: PingFangSC-Regular, PingFang SC;
        //   font-weight: 400;
        //   color: #b87fff;
        //   line-height: 44px;
        // }
        .text3 {
          font-size: 40px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #bc87ff;
          line-height: 56px;
        }
        .text3-2 {
          font-size: 40px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #73bbff;
          line-height: 56px;
        }
        .text4 {
          margin-top: -50px;
          font-size: 40px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FBF497;
          line-height: 56px;
        }
      }
      h3 {
        margin: 20px 0 0px 0;
        font-size: 72px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #ffffff;
        line-height: 108px;
      }
      div {
        height: 96px;
        font-size: 72px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #ffffff;
        line-height: 108px;
        b {
          font-size: 82px;
        }
        p {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
          margin: 0;
        }
      }
    }
    section {
      text-align: center;
      color: #ffffff;
      position: relative;
      p {
        text-align: left;

        margin: 0 0 0 23%;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
      }
      address {
        height: 44px;
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 44px;
        font-weight: normal;
        font-style: normal;
      }
      h3 {
        width: 640px;
        margin: 16px auto 0;
        height: 128px;
        background: url("../../../../assets/images/winterGame/poster/barBg.png")
          center no-repeat;
        background-size: contain;
        font-size: 56px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 128px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .autumn-2023-hbg{
        width: 640px;
        margin: 16px auto 0;
        height: 128px;
        background: url("../../../../assets/images/winterGame/poster/autumnBar.png")
          center no-repeat;
        background-size: contain;
        font-size: 56px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6DFFFD;
        line-height: 128px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .summer-2024-hbg {
        width: 640px;
        margin: 16px auto 0;
        height: 128px;
        background: url("../../../../assets/images/winterGame/poster/summer_2024_hbar.png")
          center no-repeat;
        background-size: contain;
        font-size: 56px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #F9F700;
        line-height: 128px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .summer-2025-hbg {
        width: 640px;
        margin: 16px auto 0;
        height: 128px;
        background: url("../../../../assets/images/winterGame/poster/summer_2025_hbar.png")
          center no-repeat;
        background-size: contain;
        font-size: 56px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #F9F700;
        line-height: 128px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    footer {
      margin-top: 40px;
      dl {
        text-align: center;
        margin: auto;
        dt {
          height: 48px;
          font-size: 34px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 48px;
        }
        dd {
          background: url("../../../../assets/images/winterGame/poster/barBg.png")
            center no-repeat;
          background-size: contain;
          width: 454px;

          height: 100px;

          margin-left: auto;
          margin-right: auto;
          font-size: 80px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 100px;
        }
        .autumn-bg {
          background: url("../../../../assets/images/winterGame/poster/autumnBar.png")
            no-repeat;
          background-size: contain;
          width: 454px;
          height: 100px;
          margin-left: auto;
          margin-right: auto;
          font-size: 64px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #6DFFFD;
          line-height: 100px;
        }
        .autumn-2023-bg {
          background: url("../../../../assets/images/winterGame/poster/autumnBar.png")
            no-repeat;
          background-size: contain;
          width: 454px;
          height: 100px;
          margin-left: auto;
          margin-right: auto;
          font-size: 64px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #6DFFFD;
          line-height: 100px;
        }
        .summer-2024-bg {
          background: url("../../../../assets/images/winterGame/poster/summer_2024_Bar.png")
            no-repeat;
          background-size: contain;
          width: 454px;
          height: 100px;
          margin-left: auto;
          margin-right: auto;
          font-size: 64px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #F9F700;
          line-height: 100px;
        }
        .summer-2025-bg {
          background: url("../../../../assets/images/winterGame/poster/summer_2025_Bar.png")
            no-repeat;
          background-size: contain;
          width: 454px;
          height: 100px;
          margin-left: auto;
          margin-right: auto;
          margin-top: 20px;
          font-size: 64px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #F9F700;
          line-height: 100px;
        }
        &:first-child {
          margin-bottom: 46px;
        }
      }
    }
  }
  .status_4 {
    section {
      margin-top: -160px;
      .address {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 48px;
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
      }
      .teamName {
        margin: 20px 0 0 0;
        padding: 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 32px;
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
      }
    }
  }
  .zoneName {
    margin-top: -80px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 104px;
    color: #FFFFFF;
    line-height: 146px;
    text-align: center;
    font-style: normal;
  }
  .advancement-img {
    position: absolute;
    right: 10px;
    top: 12%;
    width: 298px;
    height: 226px;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  footer {
    margin-top: 200px;
  }
  .date {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 40px;
    color: #FBF497;
    text-align: center;
    font-style: normal;
  }
  .committeeSeal-icon {
    position: absolute;
    width: 233px;
    height: 233px;
    bottom: -60%;
    right: 30px;
  }
}
</style>
